package org.solyton.solawi.bid.application.storage

import androidx.compose.runtime.*
import org.evoleq.compose.Markup
import org.evoleq.compose.modal.Modals
import org.evoleq.compose.storage.onInit
import org.evoleq.math.state.runOn
import org.evoleq.optics.storage.ActionEnvelope
import org.evoleq.optics.storage.Storage
import org.evoleq.optics.storage.onChange
import org.evoleq.optics.transform.times
import org.solyton.solawi.bid.application.data.Application
import org.solyton.solawi.bid.application.data.actions
import org.solyton.solawi.bid.application.data.env.Environment
import org.solyton.solawi.bid.application.storage.event.*
import org.solyton.solawi.bid.application.storage.middleware.ProcessAction
import org.solyton.solawi.bid.module.context.data.Context
import org.solyton.solawi.bid.module.process.data.processes.Processes
import org.solyton.solawi.bid.module.user.data.user.User


@Markup
@Composable
fun Storage(): Storage<Application> {
    // store all data related to the application
    var application by remember{ mutableStateOf<Application>(Application(
        environment = Environment(),
        userData = User()
    ))}

    var modals by remember { mutableStateOf<Modals<Int>>(mapOf()) }

    // store context outside the rendering loops
    var context: Context = Context()

    // Keep processes separate - changes shall not trigger rendering
    val processes = Processes()

    return Storage<Application>(
        read = { application.copy(
            modals = modals,
            context = context,
            processes = processes
        ) },
        write = {
            newApplication -> when{
                newApplication.context != context -> {
                    context = newApplication.context
                }
                newApplication.modals !== modals -> {
                    modals = newApplication.modals
                }
                newApplication.processes !== processes -> {
                    processes.registry.clear()
                    processes.registry.putAll(newApplication.processes.registry)
                }
                else -> {
                    application = newApplication
                }
            }
        }
    )
    .onInit {
        checkContext()
        checkCookie()
        checkUserData()
    }
    .onChange { oldApplication, newApplication ->
        onCookieDisclaimerConfirmed(oldApplication, newApplication)
        onLocaleChanged(oldApplication, newApplication)
        onLogin(oldApplication, newApplication)
    }.onDispatch {
        (this@onDispatch * actions).read().flow.collect { action : ActionEnvelope<Application,*,*> ->
            ProcessAction( action ) runOn this
        }
    }
}
